import React, { useEffect, useRef, useState } from 'react';
import { $ } from "react-jquery-plugin";
import { savePDF } from '@progress/kendo-react-pdf';
import { Grid, Text } from '@nextui-org/react';
import jsPDF from 'jspdf';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { userStore } from '../../store/userStore';
import { decode } from 'html-entities';


const ExhibitionPaymentPDF =()=> {

    const pdfRef = useRef(null);

    const todays = new Date();

    const storeData = userStore().exhibition


    useEffect(() => {

        $('html,body').animate({ scrollTop: 0 }, 'fast');
        $('body').removeClass('').addClass('sidebar-collapsed');
        
        const content = pdfRef.current;

        const doc = new jsPDF('p', 'mm', 'a4');
        doc.html(content, {
            callback: function (doc) {
                doc.save('payment_form.pdf');
            },
            html2canvas: { scale: 0.353 } 
        });
        
        setTimeout(()=>{
            localStorage.removeItem('pdfData')
        }, 5000)

    },[]);

    return (
    <div className="wrapper">
        <aside className="right-side ">
            <div style={{ padding:"50px", fontFamily:'Poppins'}} className="content-area no-header pdf-association">
                <div className='association-pdf' ref={pdfRef}>       
                    <div style={{marginTop:"20px"}}>
                        <div style={{height:"50px"}}></div>
                        <img src={require('../../images/gisalogo.png')} className="form-image" alt=''/>
                        <p style={{fontSize:'21px', fontWeight:700, textTransform:'uppercase', marginBottom:'-5px', marginTop:'20px', wordSpacing:"5px"}}>{decode(storeData?.name)}</p>
                        <p style={{fontSize:'15px', fontWeight:700, textTransform:'uppercase', marginBottom:'-8px'}}>INVOICE&nbsp;&nbsp;FOR&nbsp;&nbsp;PAYMENT BY CHECK</p>
                    </div>
                    <p style={{fontSize:'14px', marginTop:'15px',}}>Date : {moment(todays).format('MM-DD-YYYY')}</p>
                    <div>
                        <p style={{fontSize:'10px', marginTop:'28px'}}>Please&nbsp;&nbsp;print&nbsp;&nbsp;this page and mail it with your check payment to:</p>
                        <p style={{fontSize:'17px',fontWeight:500, marginTop:'28px'}} >GISA</p>
                        <p style={{fontSize:'17px',fontWeight:500, marginTop:'-10px'}} >PO Box 9</p>
                        <p style={{fontSize:'17px',fontWeight:500, marginTop:'-10px'}} >Dawsonville, GA 30534</p>
                    </div>  
                    <div style={{marginTop:'10px'}}>
                        <br /><br />
                        <Grid.Container gap={2} justify="center" className='form-last-content' style={{width:'90%'}}>
                            <Grid xs={12}>
                                <ol type="none" style={{listStyle:'none', marginBottom:"0px"}}>
                                    <li style={{paddingTop:'0px'}}>
                                        <span style={{fontSize:'14px'}}>Payment Details:</span>
                                        <hr style={{marginTop:'0px', borderColor:'rgba(0, 0, 0, 0.85)'}} />
                                    </li>
                                </ol>
                            </Grid>
                        </Grid.Container>
                        <Grid.Container gap={2} style={{width:'90%'}} className="form-last-content">
                            <Grid xs={5} style={{marginTop:'5px'}}>
                                <span style={{fontWeight:'400', fontSize:'14px'}}>Company Name:</span>
                            </Grid>
                            <Grid xs={7} style={{marginTop:'5px'}}>
                                <span style={{fontWeight:'400', fontSize:'14px'}}>{storeData?.company}</span>
                            </Grid>
                        </Grid.Container>
                        <Grid.Container gap={2} style={{width:'90%'}} className="form-last-content">
                            <Grid xs={5} style={{marginTop:'0px'}}>
                                <span style={{fontWeight:'400', fontSize:'14px'}}>Number of Tables: </span>
                            </Grid>
                            <Grid xs={7} style={{marginTop:'0px'}}>
                                <span style={{fontWeight:'400', fontSize:'14px'}}>{storeData?.tableCost?.table_num}</span>
                            </Grid>
                        </Grid.Container>
                        <Grid.Container gap={2} style={{width:'90%'}} className="form-last-content">
                            <Grid xs={5} style={{marginTop:'0px'}}>
                                <span style={{fontWeight:'400', fontSize:'14px'}}>Exhibit Fee:</span>
                            </Grid>
                            <Grid xs={7} style={{marginTop:'0px'}}>
                                <span style={{fontWeight:'400', fontSize:'14px'}}>${storeData?.tableCost?.cost}.00</span>
                            </Grid>
                        </Grid.Container>
                        {
                            storeData?.eleCost > 0 &&
                            <Grid.Container gap={2} style={{width:'90%'}} className="form-last-content">
                                <Grid xs={5} style={{marginTop:'0px'}}>
                                        <span style={{fontWeight:'400', fontSize:'14px'}}>Electricity Fee</span>
                                </Grid>
                                <Grid xs={7} style={{marginTop:'0px'}}>
                                        <span style={{fontWeight:'400', fontSize:'14px'}}>${storeData?.eleCost}.00</span>
                                </Grid>
                            </Grid.Container>
                        }
                        <Grid.Container gap={2} style={{width:'90%'}} className="form-last-content">
                            <Grid xs={5} style={{marginTop:'0px'}}>
                                <span style={{fontWeight:'400'}}>TOTAL DUE:</span>
                            </Grid>
                            <Grid xs={7} style={{marginTop:'0px'}}>
                                <span style={{fontWeight:'400'}}>${storeData?.totalCost}</span>
                            </Grid>
                        </Grid.Container>

                        <Grid.Container gap={2} style={{width:'90%'}} className="form-last-content">
                            <Grid xs={12} style={{marginTop:'40px', justifyContent:'center'}}>
                                <span style={{fontWeight:'400', fontSize:'12px'}}>If you have any questions, please contact the GISA Office at 706-938-1400.</span>
                            </Grid>
                            <Grid xs={12} style={{marginTop:'-15px', justifyContent:'center'}}>
                                <span style={{fontWeight:'400', fontSize:'12px'}}>THANK YOU!</span>
                            </Grid>
                        </Grid.Container>

                       
                    </div>
                </div>
            </div>
        </aside>
    </div>
    )
}

export default ExhibitionPaymentPDF 